module.exports = __webpack_public_path__ + "img/titan-a-wifi.446112a8.png";